import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, Col, Divider, Input, Row } from "antd";
import { useEffect, useState } from "react";
import { ERcbTier } from "@devowl-wp/api-real-cookie-banner";
import { jsxJoin } from "@devowl-wp/react-utils";
import { TemplateCenterCards } from "./cards.js";
import { useI18n } from "../../contexts/i18n.js";
import { useTemplateCenter } from "../../contexts/templateCenter.js";
import { useUpsell } from "../../contexts/upsell.js";
function TemplateCenterFilter({ children, cards, onFetched }) {
    const [busy, setBusy] = useState(false);
    const { __, _i } = useI18n();
    const { isPro, isLicensed } = useUpsell();
    const { fetchTemplates, enableLocalFilter } = useTemplateCenter();
    const [term, setTerm] = useState("");
    const [isShowOnlyFree, setShowOnlyFree] = useState(false);
    useEffect(()=>{
        if (isLicensed) {
            setBusy(true);
            fetchTemplates({
                term,
                isShowOnlyFree
            }).then((items)=>{
                let result = items;
                if (enableLocalFilter) {
                    result = result.filter(({ tier })=>isPro ? true : isShowOnlyFree ? tier !== ERcbTier.Pro : true).filter(({ headline, subHeadline })=>term.trim().length ? term.split(" ").filter(Boolean).filter((singleTerm)=>// Include description in search index
                            `${headline} ${subHeadline || ""}`.toLowerCase().indexOf(singleTerm.trim().toLowerCase()) > -1).length > 0 : true);
                }
                onFetched(result);
            }).finally(()=>{
                setBusy(false);
            });
        }
    }, [
        onFetched,
        term,
        isShowOnlyFree,
        isLicensed
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        style: {
            marginBottom: 20
        },
        children: [
            children,
            isLicensed && /*#__PURE__*/ _jsx(Input.Search, {
                autoFocus: true,
                loading: busy,
                style: {
                    maxWidth: 400
                },
                placeholder: __("Search template by name..."),
                onChange: (e)=>setTerm(e.target.value)
            }),
            /*#__PURE__*/ _jsx(Row, {
                style: {
                    marginTop: 10
                },
                justify: "center",
                align: "middle",
                gutter: [
                    10,
                    16
                ],
                children: jsxJoin([
                    !isPro && /*#__PURE__*/ _jsx(Col, {
                        children: /*#__PURE__*/ _jsx(Checkbox, {
                            onChange: ()=>setShowOnlyFree(!isShowOnlyFree),
                            disabled: !isLicensed,
                            style: {
                                marginRight: -8
                            },
                            children: __("Show only free templates")
                        }, "isShowOnlyFree")
                    }, "isShowOnlyFree")
                ].filter(Boolean), /*#__PURE__*/ _jsx(Col, {
                    children: /*#__PURE__*/ _jsx(Divider, {
                        type: "vertical"
                    })
                }))
            }),
            term.length > 0 && cards.templates.length === 0 ? /*#__PURE__*/ _jsx("div", {
                className: "notice notice-warning inline below-h2 notice-alt",
                style: {
                    margin: "10px 0 0 0",
                    maxWidth: 400,
                    display: "inline-block"
                },
                children: /*#__PURE__*/ _jsx("p", {
                    children: _i(__("{{strong}}No template found{{/strong}}. Please try to create the service yourself or {{a}}contact us{{/a}} and let us know for which service you need a template."), {
                        strong: /*#__PURE__*/ _jsx("strong", {}),
                        a: /*#__PURE__*/ _jsx("a", {
                            href: __("https://devowl.io/support/"),
                            target: "_blank",
                            rel: "noreferrer"
                        })
                    })
                })
            }) : isLicensed && /*#__PURE__*/ _jsx(TemplateCenterCards, {
                ...cards
            })
        ]
    });
}
export { TemplateCenterFilter };
